"use strict";

/* global $ */

/**
 * @typedef {Object} APP.ajax
 * @property {function(string, object):Promise} get
 * @property {function(string, object):Promise} post
 */
APP('ajax', function () {
    this.get = function (url, query) {
        return $.ajax({
            url: url,
            method: 'get',
            data: query
        });
    };
    this.post = function (url, data) {
        return $.ajax({
            url: url,
            method: 'post',
            data: $.extend({
                _token: APP.global.csrf
            }, data)
        });
    };

});

/**
 * @typedef {Object} APP.fon
 * @property {function(object):string} encode
 * @property {function(string):object} decode
 */
APP('fon', function() {
    this.encode = function(vars) {
        var list = [];
        $.each(vars, function(index, value) {
            if (Array.isArray(value)) {
                list.push(index + '*:' + value.join(','));
            } else {
                list.push(index + ':' + value);
            }
        });
        return list.join(';');
    };
    this.decode = function(str) {
        var list = str.split(';');
        var res = {};
        $.each(list, function(_, val) {
            var kv = val.split(':');
            var name = kv[0];
            var value = kv[1];
            if (name.substr(-1) === '*') {
                name = name.substr(0, name.length - 1);
                value = value.length ? value.split(',') : [];
            }
            res[name] = value;
        });
        return res;
    };
});
